import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";


export const fetchAllVendors = async () => {
    try {
        const token = getToken();
        const response = await apiService.get(API_URL.GET_VENDORS, token);
        return response;
    } catch (err) {
        console.log("Error in fetchAllVendors service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const fetchAllVendorAccounts = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.GET_HODUBLAST_ACCOUNTS, payload, token);
        return response;
    } catch (err) {
        console.log("Error in fetchAllVendorAccounts service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}